import { PLAY_SOUND, RESET_SOUND } from './actions';

interface SoundState {
  playSound: boolean;
  soundType: 'scan_success' | 'scan_failure' | null;
}

export const initialState: SoundState = {
  playSound: false,
  soundType: null,
};

interface PlaySoundAction {
  type: typeof PLAY_SOUND;
  payload: { soundType: 'scan_success' | 'scan_failure' };
}

interface ResetSoundAction {
  type: typeof RESET_SOUND;
}

type SoundActions = PlaySoundAction | ResetSoundAction;

const soundReducer = (state = initialState, action: SoundActions): SoundState => {

  switch (action.type) {
    case PLAY_SOUND:
      return { ...state, playSound: true, soundType: action.payload.soundType };
    case RESET_SOUND:
      return { ...state, playSound: false, soundType: null };
    default:
      return state;
  }
};

export default soundReducer;